/* AI Ebook Home — section script (Dawn / OS 2.0 compatible) */
(function(){
  "use strict";

  function initAiEbookHome(){
    var nav = document.getElementById('aeb-nav');
    if(!nav) return; // section not on this page

    window.addEventListener('scroll', function(){
      nav.classList.toggle('scrolled', window.scrollY > 40);
    }, {passive:true});

    var burger = document.getElementById('aeb-burger');
    if(burger){
      burger.addEventListener('click', function(){
        var links = document.querySelector('.nav-links');
        var isOpen = links.style.display === 'flex';
        links.style.cssText = isOpen ? 'display:none;' :
          'display:flex; position:fixed; top:64px; left:16px; right:16px; flex-direction:column; gap:0; background:#0c0c0c; border:1px solid rgba(255,255,255,.1); border-radius:16px; padding:8px; z-index:99;';
        links.querySelectorAll('a').forEach(function(l){
          l.style.padding = '14px 12px';
          l.style.borderBottom = '1px solid rgba(255,255,255,.06)';
        });
      });
    }

    document.querySelectorAll('.rippler, .btn-primary').forEach(function(btn){
      btn.addEventListener('click', function(e){
        var r = document.createElement('span');
        r.className = 'ripple';
        var rect = btn.getBoundingClientRect();
        r.style.left = (e.clientX - rect.left) + 'px';
        r.style.top = (e.clientY - rect.top) + 'px';
        btn.appendChild(r);
        setTimeout(function(){ r.remove(); }, 650);
      });
    });

    if('IntersectionObserver' in window){
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); }
        });
      }, {threshold:.12, rootMargin:'0px 0px -60px 0px'});
      document.querySelectorAll('.reveal').forEach(function(el){ io.observe(el); });
    } else {
      document.querySelectorAll('.reveal').forEach(function(el){ el.classList.add('in'); });
    }

    document.querySelectorAll('.faq-item').forEach(function(item){
      var q = item.querySelector('.faq-q');
      var a = item.querySelector('.faq-a');
      if(item.classList.contains('open')){ a.style.maxHeight = a.scrollHeight + 'px'; }
      q.addEventListener('click', function(){
        var isOpen = item.classList.contains('open');
        document.querySelectorAll('.faq-item.open').forEach(function(o){
          o.classList.remove('open');
          o.querySelector('.faq-a').style.maxHeight = null;
        });
        if(!isOpen){
          item.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
        }
      });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAiEbookHome);
  } else {
    initAiEbookHome();
  }

  // Re-init if Shopify theme editor re-renders this section
  document.addEventListener('shopify:section:load', function(e){
    if(e.target.querySelector('#aeb-nav')){ initAiEbookHome(); }
  });
})();